/**
 * Visitor-tracking gate (pure) — decides whether the SPA should emit
 * visitor-tracking pings for the current auth state. Kept here (a plain
 * module, no React/browser imports) so it runs under Node's built-in test
 * runner; `VisitorTracker.jsx` consumes it verbatim.
 *
 * Rules:
 *   - Only authenticated ORGANISATION members are tracked.
 *   - The platform operator (`super_admin`) is never tracked.
 *   - NEVER during an impersonation session. TaskMagix is read-only while
 *     impersonating, the acting admin is only browsing, and the server no-ops
 *     the write — so a ping would be a pointless round-trip under the borrowed
 *     identity. Skipping here also avoids the read-only write-block logging a
 *     blocked write / the browser printing a network error.
 */
export function shouldTrackVisits({ status, role, impersonation } = {}) {
  return (
    status === 'authenticated' &&
    Boolean(role) &&
    role !== 'super_admin' &&
    !impersonation
  )
}
